import { createI18n } from "vue-i18n";
import * as enUS from './en.json'
import * as zhHK from './zh.json'
import * as zhCN from './sc.json'

// Type-define 'en-US' as the master schema for the resource
type MessageSchema = typeof enUS;

export const supportedLang = ['en', 'zh', 'sc'];

const i18n = createI18n<[MessageSchema], 'en'|'zh'|'sc'>({
    locale: 'en',
    fallbackLocale: 'en',
    messages: {
        // @ts-ignore
        'en': enUS.default,
        // @ts-ignore
        'zh': zhHK.default,
        // @ts-ignore
        'sc': zhCN.default,
    }
});

export default i18n;
